import type { HostActions } from '@makemydeal/dr-activities-role-assumption';
import {
    clearRoleAssumption,
    saveRoleAssumptionUserName,
    initializingRoleAssumption
} from '@makemydeal/dr-activities-role-assumption';
import { setWorkflowEvaluation } from '@makemydeal/dr-sales-checkin-store';

export const hostActions: HostActions = {
    // Fulfils activities-role-assumption's HostActions.navigateToDashboard slot — that property
    // name is the shared interface's; SCI's own action it dispatches is INITIALIZING_ROLE_ASSUMPTION,
    // which kicks off the assumed-user init re-fetch (see sales-checkin-store/common/middleware.ts).
    navigateToDashboard: () => initializingRoleAssumption(),

    // Remove role assumption user name details from session storage
    clearRoleAssumption: (query) => clearRoleAssumption(query),

    // Store role assumption user name details in session storage
    saveRoleAssumptionUserName: (userName) => saveRoleAssumptionUserName(userName),

    startWorkflowEvaluator: () => setWorkflowEvaluation(true)
};
